import BookingsListPage from '../../shared/booking/BookingsListPage';

export default function BusBookings() {
  return <BookingsListPage module="bus" title="My bus bookings" />;
}
